import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { City } from '../models/city.model';
import { CityInfo } from '../models/city-info.model';
import { InstitutionInfo } from '../models/institution-info.model';

import { ErrorHandleService } from './error-handle.service';
import { CityInfoEndpoint } from './city-info-endpoint.service';

@Injectable({
  providedIn: 'root'
})

export class CityInfoService {

  constructor(private errorHandleService: ErrorHandleService, private cityInfoEndpoint: CityInfoEndpoint) { }

  getCityInfoes(): Observable<CityInfo[]> {
    const result: CityInfo[] = new Array();

    this.cityInfoEndpoint.getCitiesEndpoint<City[]>().subscribe(cities => {
      cities.forEach(city => {
        this.cityInfoEndpoint.getInstitutionInfoesEndpoint<InstitutionInfo[]>(city.id)
          .subscribe(institutionInfoes => {
            result.push(new CityInfo(city.cityName, institutionInfoes, city.orderNumber));

            // 市表示順並べ替え（オーダー番号順）
            result.sort((infoA, infoB) => {
              return infoA.orderNumber - infoB.orderNumber;
            });
          }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "空床情報取得中にエラーが発生しました。", error));
      });
    }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "市情報取得中にエラーが発生しました。", error));

    return of(result);
  }
}
